import { atom } from "jotai";

export const navAtom = atom({
    app: null,
    screen: null,
});
